<!--
 * @Author: your name
 * @Date: 2021-11-22 09:52:49
 * @LastEditTime: 2021-12-03 16:23:43
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/layout/Footer.vue
-->
<template>
  <div class="footer">
    <div class="footer-wrapper">
      <el-row type='flex'>
        <div class="common-pd">
          <div class="footer-title">关于我们</div>
          <div class="text-info-link footer-fix" @click="onJumpAbout">企业简介</div>
          <div class="text-info-link footer-fix" style="margin-bottom:40px;" @click="onJumpNews">新闻资讯</div>
        </div>
        <div>
          <div class="footer-title">联系我们</div>
          <el-row type='flex' align='middle' class="text-info-link footer-fix">
            <img :src="require('../assets/common/footer_address.png')" alt="">
            <span>浙江省杭州市拱墅区莫干山路949号佳源银座</span>
          </el-row>
          <el-row type='flex' align='middle' class="text-info-link footer-fix">
            <img :src="require('../assets/common/footer_email.png')" alt="">
            <span>hujiao@yaomaitong.cn</span>
          </el-row>
        </div>
      </el-row>
      <el-divider direction="vertical"></el-divider>
      <div>
        <div class="footer-title" style="margin-bottom:10px">扫码了解更多药脉通相关</div>
        <el-row type='flex'>
          <div class="align-center qr-wrapper">
            <div class="text-info-link footer-fix">药脉通微信公众号</div>
            <img :src="require('@/assets/common/wechat_qr.png')" class="qr-image" alt="">
          </div>
          <div class="align-center qr-wrapper">
            <div class="text-info-link footer-fix">药脉通APP下载</div>
            <img :src="require('@/assets/common/app_qr.png')" class="qr-image" alt="">
          </div>
        </el-row>
      </div>
    </div>
    <div class="footer-better">
      <div>
        <span>Copyright by &copy; 2021 - 2022 杭州药脉通数字科技有限公司</span>
        <a href="https://beian.miit.gov.cn/" target='view_window' style='margin-left:10px'>浙ICP备2021020932号-1</a>
        <a href='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502006635' target='view_window' style='margin-left: 10px; margin-right: 10px;'>公安机关备案号 33010502006635号</a>
        <span>互联网药品信息服务资格证：</span>
        <a href="http://cdnfile.yaomaitong.cn/image/ymtszkj_ypz.jpg" target='view_window' >（浙）—经营性—2021-0114</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data () {
    return {

    }
  },
  methods: {
    onJumpAbout () {
      window.open('/about/us')
    },
    onJumpNews () {
      window.open('/article/list')
    }
  }
}
</script>
<style lang="scss" scoped>
  .footer {
    height: 19.19vw;
    flex-shrink: 0;
    max-height: 380px;
    background-color: #2B3341;
    background-image: url('../assets/common/footer_fix.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    display: flex;
    flex-direction: column;
  }
  .footer-wrapper {
    max-width: 1280px;
    margin: 0 auto;
    flex: 1;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
  }
  .common-pd {
    padding-right: 110px;
  }
  .footer-title {
    color: #fff;
    margin-bottom:24px;
    font-size: 16px;
  }
  .footer-fix {
    height: 20px;
    margin-bottom: 16px;
    img {
      margin-right: 8px;
    }
  }
  .qr-wrapper {
    margin-right: 50px;
  }
  .el-divider {
    background-color: #60687A;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%,-50%,0);
    height: 8.85vw;
  }
  .qr-image {
    background-color: #fff;
    height: 90px;
    width: 90px;
  }
  .footer-better {
    color: #fff;
    text-align: center;
    padding-bottom: 20px;
    line-height: 2;
  }
</style>
